import { reduceToSum } from '../../util/array-utility'
import { EmissionModel } from '../../emission-coefficients/emission-coefficients'

export type MapYearIndexToValue = (yearIndex: number) => number

type YearlyValue = {
  year: number
  value: number
}

function calculateYearlyCarbonFootprints(
  mapYearIndexToValue: (yearIndex: number) => number,
  { buildingYear, inspectionLengthInYears }: EmissionModel,
): YearlyValue[] {
  const yearIndices = Array.from(Array(inspectionLengthInYears).keys())

  return yearIndices.map((yearIndex) => ({
    year: buildingYear + yearIndex,
    value: mapYearIndexToValue(yearIndex),
  }))
}

export function calculateTotalCarbonFootprint(
  mapYearIndexToValue: (yearIndex: number) => number,
  emissionModel: EmissionModel,
): number {
  const yearlyEmissions = calculateYearlyCarbonFootprints(
    mapYearIndexToValue,
    emissionModel,
  )
  return yearlyEmissions.map(({ value }) => value).reduce(reduceToSum, 0)
}
